export default "__VITE_ASSET__DoQyJhAN__"